import { Tooltip } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

interface BusinessLogMaskedBiddingTooltipProps {
  needsTooltip?: boolean;
}

export const BusinessLogMaskedBiddingTooltip = ({
  needsTooltip = false,
  children,
}: PropsWithChildren<BusinessLogMaskedBiddingTooltipProps>) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'CompetitiveBidding' });
  return needsTooltip ? (
    <Tooltip title={t('businessLog')}>
      <span>{children}</span>
    </Tooltip>
  ) : (
    <>{children}</>
  );
};
